import React, { Component } from 'react'
import store from './store'
import { observer } from 'mobx-react'
import { Button, Checkbox } from 'hljd'
import styles from '../style.module.less'
import { getObjValue } from '@hlj/hlj-utils'
import { HeaderView } from '@merchant-backend/common-components'

@observer
export default class extends Component {
  componentDidMount() {
    store.getStatus()
    store.getPromise()
    store.doLeast()
  }

  render() {
    const { list, reason, status, ids, least } = store
    let header = [
      <a href="#/localMerchant/marketingTools?key=5">商家承诺</a>,
      '设置商家承诺'
    ]

    return (
      <HeaderView header={header} title="设置商家承诺">
        <div className={styles.box}>
          {(status == 3 || status == 4) && (
            <div className={styles.pendingMsg}>
              <img src="http://qnm.hunliji.com/o_1b3c9uqm9am31qpf1rd9qr1c437.png" />
              {status == 3 && (
                <span>审核中！在审核结束后，您将收到我们的通知</span>
              )}
              {status == 4 && <span>{reason}</span>}
            </div>
          )}

          <div className={styles.service}>
            <span>请选择服务内容</span>
            <small>(至少选择{least}项)</small>
            <Button
              type="primary"
              style={{ float: 'right', marginTop: 16 }}
              onClick={store.savePromise}
            >
              保存
            </Button>
          </div>
          <div className={styles.serviceDetail}>
            <ul className={styles.promiseUl}>
              {(list || []).map(
                ({ id, detail, image_path, main, status }, index) => (
                  <li key={id}>
                    <Checkbox
                      checked={getObjValue(ids[index], 'status') == 1}
                      onChange={store.changeCheck(id, index)}
                    >
                      <span style={{ float: 'right' }}>
                        <img src={image_path} />
                        <div>
                          <p
                            style={{
                              color:
                                getObjValue(ids[index], 'status') == 1
                                  ? '#448afc'
                                  : '#333'
                            }}
                          >
                            {main}
                          </p>
                          <p
                            style={{
                              color:
                                getObjValue(ids[index], 'status') == 1
                                  ? '#448afc'
                                  : '#666'
                            }}
                          >
                            {detail}
                          </p>
                        </div>
                      </span>
                    </Checkbox>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      </HeaderView>
    )
  }
}
